import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { Table } from '@tanstack/react-table';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';

interface DataTablePaginationProps<TData> {
  table: Table<TData>;
  isLoading?: boolean;
}

export function DataTablePagination<TData>({ table, isLoading = false }: DataTablePaginationProps<TData>) {
  return (
    <div className={cn('flex items-center justify-between px-2')}>
      <div className={cn('flex-1 text-sm text-muted-foreground')}></div>
      <div className={cn('flex items-center space-x-6 lg:space-x-8')}>
        <div className={cn('flex w-[100px] items-center justify-center text-sm font-medium')}>
          {!isLoading && (
            <>
              Page {table.getState().pagination.pageIndex + 1} of {table.getPageCount()}
            </>
          )}
        </div>
        <div className={cn('flex items-center space-x-2')}>
          <Button
            variant="secondary"
            className={cn('hidden h-8 w-8 p-0 lg:flex')}
            onClick={() => table.setPageIndex(0)}
            disabled={isLoading || !table.getCanPreviousPage()}
          >
            <span className="sr-only">Go to first page</span>
            <ChevronsLeft />
          </Button>
          <Button
            variant="secondary"
            className={cn('h-8 w-8 p-0')}
            onClick={() => table.previousPage()}
            disabled={isLoading || !table.getCanPreviousPage()}
          >
            <span className="sr-only">Go to previous page</span>
            <ChevronLeft />
          </Button>
          <Button
            variant="secondary"
            className={cn('h-8 w-8 p-0')}
            onClick={() => table.nextPage()}
            disabled={isLoading || !table.getCanNextPage()}
          >
            <span className="sr-only">Go to next page</span>
            <ChevronRight />
          </Button>
          <Button
            variant="secondary"
            className={cn('hidden h-8 w-8 p-0 lg:flex')}
            onClick={() => table.setPageIndex(table.getPageCount() - 1)}
            disabled={isLoading || !table.getCanNextPage()}
          >
            <span className="sr-only">Go to last page</span>
            <ChevronsRight />
          </Button>
        </div>
      </div>
    </div>
  );
}
